<template>
  <div aria-labelledby="billing_history_heading">
    <div class="bg-white pt-6 shadow sm:rounded-md sm:overflow-hidden">
      <div class="px-4 sm:px-6 flex justify-between items-center">
        <h2 id="billing_history_heading" class="text-lg leading-6 font-medium text-gray-900">
          Third Party Services
        </h2>
        <ThirdPartyServiceListAdd :account-id="accountId" />
      </div>
      <div class="mt-6 flex flex-col">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div class="overflow-hidden border-t border-gray-200">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Service
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Channel
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Active
                    </th>
                    <th
                      scope="col"
                      class="relative px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      <span class="sr-only">Edit service</span>
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <template v-for="thirdPartyService in thirdPartyServices">
                    <WoocommerceApiServiceListLine
                      v-if="thirdPartyService.service === 'woocommerce'"
                      :key="thirdPartyService.id"
                      :third-party-service="thirdPartyService"
                    />
                    <SoftOneApiServiceListLine
                      v-else-if="thirdPartyService.service === 'softone'"
                      :key="thirdPartyService.id"
                      :third-party-service="thirdPartyService"
                    />
                    <FacebookServiceListLine
                      v-else-if="thirdPartyService.service === 'facebook'"
                      :key="thirdPartyService.id"
                      :third-party-service="thirdPartyService"
                    />
                    <CustomEmailServiceListLine
                      v-else-if="thirdPartyService.service === 'custom email'"
                      :key="thirdPartyService.id"
                      :third-party-service="thirdPartyService"
                    />
                    <ThirdPartyServiceListLine
                      v-else
                      :key="thirdPartyService.id"
                      :third-party-service="thirdPartyService"
                    />
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ThirdPartyServiceListAdd from './ThirdPartyServiceListAdd.vue';
import ThirdPartyServiceListLine from './ThirdPartyServiceListLine.vue';
import WoocommerceApiServiceListLine from './thirdPartyServiceList/WoocommerceApiServiceListLine.vue';
import SoftOneApiServiceListLine from './thirdPartyServiceList/SoftOneApiServiceListLine.vue';
import FacebookServiceListLine from './thirdPartyServiceList/FacebookServiceListLine.vue';
import CustomEmailServiceListLine from './thirdPartyServiceList/CustomEmailServiceListLine.vue';

export default {
  components: {
    ThirdPartyServiceListLine,
    WoocommerceApiServiceListLine,
    SoftOneApiServiceListLine,
    ThirdPartyServiceListAdd,
    FacebookServiceListLine,
    CustomEmailServiceListLine,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    thirdPartyServices: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
